import { PlanningDnDPanel } from "../components/PlanningDnDPanel";
import { PlanningPointerDragBridge } from "../components/PlanningPointerDragBridge";
import { PlanningPage } from "./PlanningPage";

export function PlanningEnhancedPage() {
  return (
    <>
      <PlanningPage />
      <PlanningDnDPanel />
      <PlanningPointerDragBridge />
    </>
  );
}
